import endOfPrevDay from 'helpers/endOfPrevDay';
import { PropertyBooking } from 'store/propertyBooking/interfaces';

const dayInSeconds = 86400;

const getDateTo = (booking: PropertyBooking) => {
  if (!booking.dateTo) {
    return '';
  }
  if (booking.duration % dayInSeconds === 0) {
    return endOfPrevDay(booking.dateTo);
  }

  return booking.dateTo;
};

export default getDateTo;
